import { useStaticQuery, graphql } from "gatsby"

export const useSearchContentQuery = () => {

  const query = useStaticQuery(
    graphql`
      {
        contentPage(type: {eq: "SearchPanel"}) {
          data
        }
      }
    `
  )
  
  return query?.contentPage?.data || {}
}


